export default __webpack_public_path__ + "static/media/matita-ambiente-grammatica-NC.109f7ada.svg";